module.exports = __webpack_public_path__ + "static/media/logo.46c62cd6.svg";